module.exports = __webpack_public_path__ + "img/2.e37db0f0.jpg";